import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { TableModalActions } from '../../TableModal'

import EditIcon from '../../../icons/edit.svg'

function ConnectedRequestsPreviewActions({
  ButtonMassEdit,
  buttonAttachProps,
  buttonMassEditProps: {
    beforeIconProps: buttonMassEditBeforeIconProps = { Icon: EditIcon },
    text: buttonMassEditText = 'ConnectedRequestsMassEdit.ButtonKey',
    ...buttonMassEditProps
  } = EMPTY_OBJECT,
  isSkeleton,
}) {
  const { t } = useTranslation()

  return (
    <TableModalActions
      ButtonCancel={null}
      buttonAttachProps={buttonAttachProps}
      isSkeleton={isSkeleton}
    >
      {ButtonMassEdit ? (
        <ButtonMassEdit
          {...buttonMassEditProps}
          beforeIconProps={buttonMassEditBeforeIconProps}
          isSkeleton={isSkeleton}
          text={t(buttonMassEditText)}
        />
      ) : null}
    </TableModalActions>
  )
}

export default ConnectedRequestsPreviewActions
